import { InputTag } from 'mixs/base/input_mixin';
import { AJAX_ACCECCING, AJAX_ACCECCED } from 'apps/events';
import TimeLag from 'utilities/timelag';

export default class ButtonWithLoading extends InputTag {
  public onAjaxAcceccedEvent:  (e) => void;
  public onAjaxAcceccingEvent: (e) => void;
  public lag: TimeLag;
  public isLoading: boolean = false;
  init(){
    super.init();
    if(this.opts.form_scope) {
      this.lag = new TimeLag(()=>{this.onTimeLag()}, 800);
      this.onAjaxAcceccedEvent  = (e) => { this.onAjaxAccecced(e); };
      this.onAjaxAcceccingEvent = (e) => { this.onAjaxAcceccing(e); };
      document.addEventListener(AJAX_ACCECCED,  this.onAjaxAcceccedEvent);
      document.addEventListener(AJAX_ACCECCING, this.onAjaxAcceccingEvent);
    }
  }
  isLoadingTargetForm(formTagScope){
    return formTagScope == this.opts.form_scope;
  }
  onAjaxAcceccing(e) {
    if(this.isLoadingTargetForm(e.detail)) {
      this.lag.clear();
      this.isLoading = true;
      this.update();
    }
  }
  onAjaxAccecced(e) {
    if(this.isLoadingTargetForm(e.detail)) {
      this.lag.start();
    }
  }
  onTimeLag(){
    this.isLoading = false;
    this.update();
  }
}
